import React from 'react';
import { useTranslation } from 'react-i18next';
import { XStack, YStack } from 'tamagui';

import { WidgetCard, SkeletonBox } from '../../../components/common';

export const WeatherUpcomingWeatherCardSkeleton = () => {
  const { t } = useTranslation();

  return (
    <WidgetCard
      title={t('weather.upcomingWeather')}
      isDraggable={false}
      dragHandleProps={null}
      error={false}
      gap="$3.5">
      <YStack gap="$3.5" justifyContent="space-between" flex={1}>
        <XStack width="100%" justifyContent="space-between" alignItems="center">
          <YStack gap="$2">
            <SkeletonBox height={60} width={120} />
            <SkeletonBox height={28} width={100} />
          </YStack>
          <SkeletonBox height={119} width={119} borderRadius="$6" />
        </XStack>

        <XStack
          backgroundColor="$transparentBorder"
          padding="$5"
          borderRadius="$6"
          justifyContent="space-between"
          height="183px">
          {Array.from({ length: 5 }).map((_, index) => (
            <YStack alignItems="center" key={index} gap="12px">
              <SkeletonBox height={24} width={40} />
              <SkeletonBox height={36} width={36} borderRadius="$6" />
              <SkeletonBox height={22} width={30} />
            </YStack>
          ))}
        </XStack>
      </YStack>
    </WidgetCard>
  );
};
